<template>
<div class="customer-quote">
  <div class="customer-quote-middle">
    <span class="quote-sign">“</span>{{quote}}<span class="quote-sign">”</span><br><span class="name">/{{name}}</span>
  </div>
</div>
</template>
<script>
export default {
  props: {
    quote: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~style/variables.less';

  .customer-quote {
    background-color: @color-grey-light;
    width: 100%;
    min-height: 40px;
    font-size: @font-size-medium;
    padding: 20px;
    margin: 0px;
    text-align: center;
    box-sizing: border-box;
    display: flex;
    justify-content: center;

    @media (max-width: @width-max) {
      font-size: @font-size-small;
    }
  }

  .customer-quote-middle {
    max-width: @width-max;
  }

  .name {
    font-size: @font-size-small;
  }

  .quote-sign {
    font-family: 'Times New Roman', Times, serif;
    font-size: @font-size-large;
    color: #888;
  }
</style>
